import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './Button.styles.js';

const Button = (props) => {
  const {
    backgroundColor,
    color,
    border = 'none',
    width,
    height,
    hoverBGColor,
    hoverColor,
    type,
    onClick,
    margin,
    roleName,
  } = props;
  return (
    <Styled.Button
      variant="contained"
      size="large"
      backgroundColor={backgroundColor}
      color={color}
      border={border}
      width={width}
      height={height}
      hoverBGColor={hoverBGColor}
      hoverColor={hoverColor}
      type={type}
      onClick={onClick}
      margin={margin}
      role={roleName}
    >
      {props.children}
    </Styled.Button>
  );
};

export default Button;

Button.propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  border: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  hoverBGColor: PropTypes.string,
  hoverColor: PropTypes.string,
  children: PropTypes.any,
  type: PropTypes.string,
  onClick: PropTypes.func,
  margin: PropTypes.string,
  roleName: PropTypes.string,
};
